import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ReqResService } from '../../service/req-res.service';
import { AuthService } from '../../service/auth/auth.service'
import { PluginService } from '../../service/plugin.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { debounce } from 'lodash';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css'],
})
export class AppLayoutComponent implements OnInit {
  public static loadedMapApi: boolean = false;
  favoritetMenus: any;
  menus: any;
  toggleButtonTitle: string;
  //password variable
  userData: any = [];
  formValue: any;
  userPasswordForm: FormGroup;
  userPasswordChangeForceForm: FormGroup;
  submitted = false;
  userPassword: string;
  errorPassword: string = "";
  reportIssue: string = "";
  //
  public _authService;

  public static _userId: number = 0;
  public static _image: string = "";
  public static _firstName: string = "";
  public static _lastName: string = "";
  public static _forceChangeOpe: boolean = false;
  recentProjectsList: any = [];
  recentProspectsList: any = [];
  constructor(private reqRes: ReqResService, private authService: AuthService,
    private pluginService: PluginService, private formBuilder: FormBuilder) {
    this._authService = this.authService;
    this.showSearchedData = debounce(this.showSearchedData, 1000)

  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    $('.modal-backdrop').remove();
  }
  @HostListener('window:basketUpdated')
  onBasketUpdated() {
    this.basketCount = this.getBasketCount();
  }
  @HostListener('click', ['$event'])
  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
    $('[data-toggle="tooltip"]').on('mouseleave', function () {
      $(this).tooltip('dispose');
    });

  }
  bindAccordinMenuOpe: boolean = false;

  ngOnInit(): void {
    let $this = this;
    this.getMenus();
    this.getUserInfo();

  


    setTimeout(() => {
      this.basketCount = this.getBasketCount();
    }, 500);
    setTimeout(function () {
      $('.cke_toolbox').attr('style', 'display:flex');
      $('.cke_top').attr('style', 'background-color:#f9fafd!important');
      $('.cke_bottom').attr('style', 'padding:0 !important');
    }, 500)
    $('.modal').on('shown.bs.modal', function () {
      $(this).find('[autofocus]').focus();
    });

   
  
    setTimeout(function () {
      $(document).on('click', function () {
        $('#navbarStandard').collapse('hide');
      });
    
    }, 200);


    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });

  
    this.pluginService.mouserOverVertical();

    this.userPasswordForm = this.formBuilder.group({
      ope: 2,
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
    this.userPasswordChangeForceForm = this.formBuilder.group({
      ope: 3,
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/)
        ]
      ],
      confirmPassword: ['', Validators.required],
    });
  }
  hasForcePasswordNumber(): boolean {
    return /[0-9]/.test(this.userPasswordChangeForceForm?.value?.newPassword || '');
  }

  hasForcePasswordSymbol(): boolean {
    return /[^A-Za-z0-9]/.test(this.userPasswordChangeForceForm?.value?.newPassword || '');
  }

  hasForcePasswordUppercase(): boolean {
    return /[A-Z]/.test(this.userPasswordChangeForceForm?.value?.newPassword || '');
  }



  hasPasswordNumber(): boolean {
    return /[0-9]/.test(this.userPasswordForm?.value?.newPassword || '');
  }

  hasPasswordSymbol(): boolean {
    return /[^A-Za-z0-9]/.test(this.userPasswordForm?.value?.newPassword || '');
  }

  hasPasswordUppercase(): boolean {
    return /[A-Z]/.test(this.userPasswordForm?.value?.newPassword || '');
  }


  closeNavItem() {
    $("#navbar-nav > li").each(function () {
      let ul = $(this).find('ul');
      $(ul).find('li').each(function () {
        let ul2 = $(this).find('ul');
        if (ul2.first().attr('id') != undefined) {
          $('#' + ul2.first().attr('id')).collapse('hide');
        }
      })
    });
  }
  closeNavBar(ope) {
    if (ope == 1) {
      $("#navbar-nav > li").each(function () {
        let ul = $(this).find('ul');
        if (ul.first().attr('id') != undefined) {
          $('#' + ul.first().attr('id')).collapse('hide');
        }
        $(ul).find('li').each(function () {
          let ul2 = $(this).find('ul');
          if (ul2.first().attr('id') != undefined) {
            $('#' + ul2.first().attr('id')).collapse('hide');
          }
        })
      });
    }
    if (window.innerWidth < 1199) { $('#navbarVerticalCollapse').toggleClass('show'); }
  }
  hideCollapse() {
    $(".navbar-collapse").collapse('hide');
  }
  getMenus() {
    this.reqRes.getData('/Layout/GetMenus/Menu').subscribe(data => {
      this.menus = data;
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
 
  getUserInfo() {
    this.reqRes.getData('/Layout/GetUserInfo').subscribe(data => {
      AppLayoutComponent._userId = data.id;
      AppLayoutComponent._image = data.image;
      AppLayoutComponent._firstName = data.firstName;
      AppLayoutComponent._lastName = data.lastName;
      AppLayoutComponent._forceChangeOpe = data.forceChangeOpe;

      if (AppLayoutComponent._forceChangeOpe) {
        this.forceChangePassword();
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
  logOut() {
    this.authService.isNotAuthencatedUrl = "/login";
    this._authService.logout();
  }
  spinner: boolean = false;
  //#region "Password"
  forceChangePassword() {
    this.userPasswordChangeForceForm = this.formBuilder.group({
      ope: 3,
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/)
        ]
      ],
      confirmPassword: ['', Validators.required],
    });

    $("#modal_change_password_force").modal("show");
    this.spinner = false;
  }

  editPassword() {
    this.userPasswordForm = this.formBuilder.group({
      ope: 2,
      oldPassword: ['', Validators.required],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/)
        ]
      ],
      confirmPassword: ['', Validators.required],
    });

    $("#modal_password").modal("show");
    this.spinner = false;
  }
  resertForm() {
    this.userPasswordForm.setValue({
      ope: 2,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });

    this.userPasswordChangeForceForm.setValue({
      ope: 3,
      newPassword: '',
      confirmPassword: '',
    });
  }
  getUserData(type) {
    this.reqRes.getData('/Settings/GetUserData/' + type).subscribe(data => {
      this.userData = data;
      this.userPassword = data[0].password;
      this.resertForm();
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
  onSubmit() {
    this.submitted = true;
    this.spinner = true;
    this.formValue = this.userPasswordForm.value;
    this.reqRes.postData('/Settings/UserOperation', this.formValue).subscribe(data => {
      if (!data.error) {
        toastr.success("Done!", '', { timeOut: 1000 });
        $("#modal_password").modal("hide");
        setTimeout(() => {
          this.logOut();
        }, 800);
      } else {
        this.errorPassword = data.error;
        this.resertForm();
      }
      this.spinner = false;
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      this.resertForm();
    });
  }
  onPasswordKeyup() {
    this.errorPassword = "";
  }

 
  //#endregion "Password"


  //#region FORCECHANGEPASS

  onPasswordForceKeyup() {
    this.errorPassword = "";
  }
  onSubmitForce() {
    this.submitted = true;
    this.spinner = true;
    this.formValue = this.userPasswordChangeForceForm.value;
    this.reqRes.postData('/Settings/UserOperation', this.formValue).subscribe(data => {
      if (!data.error) {
        toastr.success("Password changed successfully. Please login again.", '', { timeOut: 1000 });
        $("#modal_change_password_force").modal("hide");

        setTimeout(() => {
          this.logOut();
        }, 800);
      } else {
        this.errorPassword = data.error;
        this.resertForm();
      }
      this.spinner = false;
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      this.resertForm();
    });
  }
  //#endregion FORCECHANGEPASS


  
  //#region "Report issue"

  @ViewChild('myfileInput')
  myfileInputVariable: ElementRef;
  showReport() {
    this.reportIssue = "";
    $("#modal_report_issue").modal("show");
    $('#myfileInput').val(null);
    this.Files = [];
    this.spinner = false;
  }

  Files: any = [];


  drawingInstance: any;
  file: File = null;
  fileOpe = false;
  selectedFiles: any = [];
  fileChangeEvent(files: FileList) {
    this.spinner = true;
    this.fileOpe = true;
    this.Files = [];
    this.selectedFiles = [];
    if (files.length === 0) {
      return;
    }
    for (let i = 0; i < files.length; i++) {
      this.selectedFiles.push(files[i]);
    }

    const formData = new FormData();
    this.selectedFiles.forEach((f) => formData.append('Files', f));

    formData.append('type', 'Feedback' + AppLayoutComponent._userId);

    this.reqRes.postData('/Global/UploadFile', formData).subscribe(data => {
      this.Files = data;
      this.spinner = false;
      this.fileOpe = false;
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error);
    })




  }


  sendReport() {
    let obj: any = {};
    obj.template = this.reportIssue;
    obj.files = this.Files;
    $('#reportSend').attr('disabled', 'disabled');
    $("#modal_report_issue").modal("hide");
    this.reqRes.postData('/Layout/SendReport', obj).subscribe(data => {
      setTimeout(function () {
        $('#reportSend').removeAttr('disabled');
      }, 500);
      toastr.success("Done!", '', { timeOut: 1000 });
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      this.resertForm();
    });
  }
  //#endregion "Report issue"


  

  recentOpe: number = 0;
  seachOpe: number = 0;
  globalSearch: string = '';
  searchData: any = [];
  searchedProjectsList: any = [];
  searchedProspectsList: any = [];
  searchedEstimatesList: any = [];
  searchedInvoicesList: any = [];
  searchedCOList: any = [];
  searchedPOList: any = [];
  
  recentList: any = [];

  showSearchedData() {
    this.globalSearch = $("#globalSearch").val()
    if (this.globalSearch.length >= 2) {
      this.searchText = 'Searching';
      this.getSearchedDataObservable().subscribe(data => {
        this.searchData = data
        if (this.searchData?.length == 0) {
          this.searchText = 'No results found'
        }
        this.searchedProjectsList = data.filter(item => item.type == 'project');
        this.searchedProspectsList = data.filter(item => item.type == 'lead');
        this.searchedEstimatesList = data.filter(item => item.type == 'estimate');
        this.searchedInvoicesList = data.filter(item => item.type == 'invoice');
        this.searchedCOList = data.filter(item => item.type == 'co');
        this.searchedPOList = data.filter(item => item.type == 'po');
     },
       error => { toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 }) },
       () => { //console.log("Completed")

       }
     )
    }
  }


  searchText: string = '';
  getSearchedDataObservable(): Observable<any> {

    this.globalSearch = $("#globalSearch").val()
    this.seachOpe = (this.globalSearch.length >= 2) ? 1 : 0;
    this.recentOpe = (this.globalSearch.length >= 2) ? 0 : 1;
    let GridParametrs: any = {};
    GridParametrs.filter = this.globalSearch;
      return this.reqRes.postData('/Layout/GlobalSearch', GridParametrs).pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
  }

  showRecentData() {
    this.globalSearch = $("#globalSearch").val()
    this.seachOpe = (this.globalSearch.length < 2) ? 0 : 1;
    if (this.seachOpe) {
      $(".dropdown-menu-recent").addClass("show");
      $(".btn-recent-close").removeClass("d-none");
      $(".btn-recent-close").addClass("d-inline-block");
    }
  }
  resertGlobalSearch() {
    this.globalSearch = $("#globalSearch").val()
    this.globalSearch = '';
  }

  closeRecentDropDown() {
    setTimeout(() => {
      $(".btn-recent-close").removeClass("d-inline-block");
      $(".btn-recent-close").addClass("d-none");
      $(".dropdown-menu-recent").removeClass("show");
    }, 200)
  }
  basketCount: number = 0;
  getBasketCount(): number {
    const userId = AppLayoutComponent._userId;
    const storageKey = `basket_${userId}`;

    const basket = JSON.parse(localStorage.getItem(storageKey) || '[]');

    return basket.length; 
  }


}
